import React, { useState } from 'react'
import LightModeIcon from '@mui/icons-material/LightMode'
import NightlightIcon from '@mui/icons-material/Nightlight'

const ThemeSwitcher = () => {
    const handleSwitch = () => {
        localStorage.setItem('theme', JSON.stringify(!switcher))
        setSwitcher(!switcher)
    }
    const [switcher, setSwitcher] = useState(localStorage.getItem('theme') === 'true')
    return (
        <div style={{height: 24}}>
            <button id='themeSwitcher' className={switcher ? 'dark' : 'light'} onClick={() => handleSwitch()}>
                {switcher ? 
                 <NightlightIcon sx={{fill: "#fff", cursor: 'pointer'}}/> : <LightModeIcon sx={{fill: "#fff", cursor: 'pointer'}}/> }
            </button>
        </div>
    )
}

export default ThemeSwitcher